import React from "react";
import type { SpecsModel } from "../../specsModel/SpecsModel";
import { useSpecsModel, useSpecsModelSelector } from "../../SpecsModelContext";
import { SpecsMultiAutocompleteField } from "../../SpecsEditorFields/index";

type SpecsModelMultiAutocompleteFieldProps = Omit<
  React.ComponentProps<typeof SpecsMultiAutocompleteField>,
  "value" | "onChange"
> & {
  selector: (model: SpecsModel) => string[];
  setValue: (model: SpecsModel, nextValue: string[]) => void;
};

export default function SpecsModelMultiAutocompleteField({
  selector,
  setValue,
  ...props
}: SpecsModelMultiAutocompleteFieldProps) {
  const model = useSpecsModel();
  const value = useSpecsModelSelector(selector);

  const handleChange = React.useCallback(
    (nextValue: string[]) => {
      setValue(model, nextValue);
    },
    [model, setValue]
  );

  return (
    <SpecsMultiAutocompleteField
      {...props}
      value={value}
      onChange={handleChange}
    />
  );
}
